import {
    StateCodesPage,
    ServiceCodesPage,
    OrganizationCodesPage,
    SocialBenefitsPage,
    FinancialBenefitsPage,
    TicketTypesPage,
    ApartmentPricesPage,
    UsersPage
} from '@pages';

export const SettingsTabs = () => {
    return [
        {
            label: 'Prestations financières',
            path: 'financial-benefits',
            component: <FinancialBenefitsPage />
        },
        {
            label: 'Prestations sociales',
            path: 'social-benefits',
            component: <SocialBenefitsPage />
        },
        {
            label: 'Codes état',
            path: 'state-codes',
            component: <StateCodesPage />
        },
        {
            label: 'Codes organisme',
            path: 'organization-codes',
            component: <OrganizationCodesPage />
        },
        {
            label: 'Codes service',
            path: 'service-codes',
            component: <ServiceCodesPage />
        },
        {
            label: 'Type de billets',
            path: 'ticket-types',
            component: <TicketTypesPage />
        },
        {
            label: 'Tarifs des appartements',
            path: 'apartment-prices',
            component: <ApartmentPricesPage />
        },
        {
            label: 'Utilisateurs',
            path: 'users',
            component: <UsersPage />
        }
    ];
};
